import { ROLES } from '../constants/roles';

export const PERMISSIONS = {
  [ROLES.MANAGER]: [
    'upload_csv',
    'edit_diamond',
    'add_diamond',
    'delete_diamond',
    'change_status',
    'view_inventory',
    'reserve_for_client',
    'approve_reservations',
    'manage_users',
    'manage_orders',
    'manage_clients',
    'edit_order_item_price',
    'edit_order_item_weight',
    'see_buy_prices',
    'manage_checks',
    'apply_check_discount',
    'remove_check_item',
    'manage_inventory_requirements',
    'view_audit_logs',
    'view_dashboard_inventory',
    'view_dashboard_open_balance',
    'view_dashboard_today',
    'view_dashboard_monthly_payments',
    'view_dashboard_monthly_orders',
    'view_dashboard_monthly_cancellations',
    'allow_pref_months_metrics',
  ],
  [ROLES.EMPLOYEE]: [
    'change_status',
    'view_inventory',
    'approve_reservations',
    'manage_orders',
  ],
  [ROLES.CLIENT]: [
    'view_inventory',
    'request_reservation',
    'auto_reserve',
  ],
};

/**
 * @param {string} role
 * @param {string} permission
 * @param {string[] | null | undefined} customPermissions — from user.customPermissions; empty/absent uses role defaults
 */
export const PERMISSION_SECTIONS = [
  {
    key: 'inventory',
    permissions: [
      'view_inventory',
      'add_diamond',
      'edit_diamond',
      'delete_diamond',
      'upload_csv',
      'see_buy_prices',
      'manage_inventory_requirements',
    ],
  },
  {
    key: 'orders',
    permissions: [
      'manage_orders',
      'change_status',
      'approve_reservations',
      'reserve_for_client',
      'edit_order_item_price',
      'edit_order_item_weight',
    ],
  },
  {
    key: 'clients',
    permissions: ['manage_clients'],
  },
  {
    key: 'checks',
    permissions: ['manage_checks', 'apply_check_discount', 'remove_check_item'],
  },
  {
    key: 'dashboard',
    permissions: [
      'view_dashboard_inventory',
      'view_dashboard_open_balance',
      'view_dashboard_today',
      'view_dashboard_monthly_payments',
      'view_dashboard_monthly_orders',
      'view_dashboard_monthly_cancellations',
      'allow_pref_months_metrics',
    ],
  },
  {
    key: 'admin',
    permissions: ['manage_users', 'view_audit_logs'],
  },
];

export function hasPermission(role, permission, customPermissions) {
  if (customPermissions && Array.isArray(customPermissions) && customPermissions.length > 0) {
    return customPermissions.includes(permission);
  }
  return PERMISSIONS[role]?.includes(permission) || false;
}

export function hasAnyPermission(role, permissions, customPermissions) {
  return permissions.some((p) => hasPermission(role, p, customPermissions));
}
